export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="22.5" stroke="#D4AF37" strokeWidth="1.2" opacity="0.6" />
    <path d="M24 9 C 19.5 17, 19.5 25, 24 31.5 C 28.5 25, 28.5 17, 24 9 Z" fill="#D4AF37" />
    <path d="M11.5 19.5 C 16.5 23, 20.5 27.5, 23 33.5 C 21.5 25.5, 17.5 20.5, 11.5 19.5 Z" fill="#C87D55" />
    <path d="M36.5 19.5 C 31.5 23, 27.5 27.5, 25 33.5 C 26.5 25.5, 30.5 20.5, 36.5 19.5 Z" fill="#C87D55" />
    <path d="M24 33.5 C 21 36.5, 17 37.5, 13 36.5 C 17 39.5, 31 39.5, 35 36.5 C 31 37.5, 27 36.5, 24 33.5 Z" fill="#D4AF37" opacity="0.85" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={compact ? 32 : 38} />
    <span className="flex flex-col leading-none">
      <span className="font-serif-display text-xl sm:text-2xl tracking-[0.18em] text-cream">
        BELONG
      </span>
      <span className="text-[9px] tracking-[0.42em] uppercase text-gold/90 mt-1">
        Saloon &amp; Spa
      </span>
    </span>
  </span>
);
